import React, { useMemo } from 'react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import clsx from 'clsx'
import styles from './styles.module.scss'

type GlobalMenuProps = {
  used?: string
  onCloseMenu?: () => void
  memberId?: number
}

export default function GlobalMenu({ used, onCloseMenu, memberId }: GlobalMenuProps) {
  const pathname = usePathname()

  const memberMenu = useMemo(
    () => [
      {
        nameJa: 'マイページ',
        nameEn: 'mypage',
        link: '/members/mypage',
      },
      {
        nameJa: '新着記事',
        nameEn: 'contents',
        link: '/contents',
      },
      {
        nameJa: '企業検索',
        nameEn: 'companies',
        link: '/companies',
      },
      {
        nameJa: '特集',
        nameEn: 'feature',
        link: '/feature',
      },
    ],
    [],
  )

  const defaultMenu = useMemo(
    () => [
      {
        nameJa: 'はじめての方へ',
        nameEn: 'guide',
        link: '/talentbook_guide',
      },
      {
        nameJa: '新着記事',
        nameEn: 'contents',
        link: '/contents',
      },
      {
        nameJa: '企業検索',
        nameEn: 'companies',
        link: '/companies',
      },
      {
        nameJa: '特集',
        nameEn: 'feature',
        link: '/feature',
      },
    ],
    [],
  )

  const gnavList = useMemo(() => {
    if (memberId && used === 'sidenav') {
      return memberMenu.filter((item) => item.nameJa !== 'マイページ')
    } else if (memberId) {
      return memberMenu
    } else {
      return defaultMenu
    }
  }, [memberId, used, defaultMenu, memberMenu])

  const activeLinks = useMemo(() => {
    return gnavList.map((nav) => ({
      ...nav,
      isActive: pathname === nav.link,
    }))
  }, [gnavList, pathname])

  const closeMenu = () => {
    if (onCloseMenu) {
      onCloseMenu()
    }
  }

  const getNavLinkClass = (gnav: { link: string; isActive: boolean }) => {
    const classNames = [styles.headerNavItem]

    if (gnav.isActive) {
      classNames.push(styles.active)
    }

    if (gnav.link === '/talentbook_guide') {
      classNames.push(styles.buttonStyle)
    }

    return classNames.join(' ')
  }

  return (
    <ul
      className={clsx(styles.headerNavGroup, {
        [styles.member]: memberId,
        [styles.sidenavList]: used === 'sidenav',
      })}
    >
      {activeLinks.map((gnav) => (
        <li key={gnav.nameEn} className={getNavLinkClass(gnav)} onClick={closeMenu}>
          <Link
            href={gnav.link}
            className={clsx(styles.headerNavLink, { [styles.active]: gnav.isActive })}
          >
            <span className={styles.navLine}>{gnav.nameJa}</span>
          </Link>
        </li>
      ))}
    </ul>
  )
}
